import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'USUARIO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('usuarioForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/usuario?usuario=true`);
    return {
        type: 'USUARIO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/usuario`, {
				...registro,
				data_nascimento: DateFormat.formatarDataTelaParaSql(registro.data_nascimento),
				data_admissao: DateFormat.formatarDataTelaParaSql(registro.data_admissao),
				data_desligamento: DateFormat.formatarDataTelaParaSql(registro.data_desligamento),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/usuario`, {
				...registro,
				data_nascimento: DateFormat.formatarDataTelaParaSql(registro.data_nascimento),
				data_admissao: DateFormat.formatarDataTelaParaSql(registro.data_admissao),
				data_desligamento: DateFormat.formatarDataTelaParaSql(registro.data_desligamento),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function alterarsenha(registro) {
    return (dispatch, getState) => {
	    axios.post(`${consts.API_URL}/usuario/alterarsenha`, {
			...registro,
			id_usuario_alteracao: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/usuario?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaPerfil() {
    const request = axios.get(`${consts.API_URL}/usuarioPerfil/listarSelect`);
    return {
        type: 'USUARIO_PERFIL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCliente() {
    const request = axios.get(`${consts.API_URL}/cliente/listarSelect`);
    return {
        type: 'USUARIO_CLIENTE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'USUARIO_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaSetor() {
    const request = axios.get(`${consts.API_URL}/setor/listarSelect`);
    return {
        type: 'USUARIO_SETOR_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCargo() {
    const request = axios.get(`${consts.API_URL}/cargo/listarSelect`);
    return {
        type: 'USUARIO_CARGO_SELECT_LISTADO',
        payload: request
    };
}
